
import BajiePayment from './index.vue'
export default BajiePayment
